import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import clsx from 'clsx';

import useStyles from '../../Main.style';
import { formatToCurrency, getLoggedInUserData, toProperCase } from '../../../../utils/Helper';

const CollectionReport = ({
  collectionDataFromImportProp,
  pastDueInvoicesArr,
  pastDueTableArr,
  totalCellAmount,
  totalCountryAmount,
  isFromImport,
}) => {
  const classes = useStyles();
  const loggedInUserData = getLoggedInUserData();
  const [show, setShow] = useState(true);
  const [pastDueTableObject, setPastDueTableObject] = useState([]);
  const [cellDetails] = useState(loggedInUserData?.cell);
  const [isLoaded] = useState(true);
  const [displayedTcData, setDisplayedTcData] = useState([]);
  const [pastDueTop5Collection, setPastDueTop5Collection] = useState('');
  async function findObjectBySearchText(obj, searchText) {
    if (typeof obj === 'object') {
      let result;

      if (Array.isArray(obj)) {
        for (let i = 0; i < obj?.length; i += 1) {
          result = await findObjectBySearchText(obj[i], searchText);
          if (result) {
            return result;
          }
        }
      } else {
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            result = await findObjectBySearchText(obj[prop], searchText);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj };
            }
          }
        }
      }
    }
    return null;
  }
  const fillPastDueTotals = async (reportObj) => {
    const tableData = [];
    let totalCellCollection = 0;
    const columnTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    reportObj?.Rows?.Row?.sort((ad, bd) => {
      const adVal =
        ad?.ColData &&
        Number(ad?.ColData[2]?.value) +
          Number(ad?.ColData[3]?.value) +
          Number(ad?.ColData[4]?.value) +
          Number(ad?.ColData[5]?.value) +
          Number(ad?.ColData[6]?.value) +
          Number(ad?.ColData[7]?.value);
      const bdVal =
        bd?.ColData &&
        Number(bd?.ColData[2]?.value) +
          Number(bd?.ColData[3]?.value) +
          Number(bd?.ColData[4]?.value) +
          Number(bd?.ColData[5]?.value) +
          Number(bd?.ColData[6]?.value) +
          Number(bd?.ColData[7]?.value);
      if (adVal && bdVal) {
        return bdVal - adVal;
      } else if (adVal) {
        return -1;
      } else if (bdVal) {
        return 1;
      } else {
        return 0;
      }
    }).map((c, index) => {
      if (c?.ColData) {
        if (index < 5) {
          columnTotal[0] += parseFloat(
            c?.ColData[2]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[2]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0,
          );
          columnTotal[1] += parseFloat(
            c?.ColData[1]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[1]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[2] += parseFloat(
            c?.ColData[3]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[3]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[3] += parseFloat(
            c?.ColData[4]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[4]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[4] += parseFloat(
            c?.ColData[5]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[5]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[5] += parseFloat(
            c?.ColData[6]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[6]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[6] += parseFloat(
            c?.ColData[7]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[7]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[7] += parseFloat(
            c?.ColData[8]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[8]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[8] = Number(
            columnTotal[0] +
              columnTotal[2] +
              columnTotal[3] +
              columnTotal[4] +
              columnTotal[5] +
              columnTotal[6] +
              columnTotal[7],
          );

          columnTotal[9] += parseFloat(
            c?.ColData[9]?.value === ''
              ? (0).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : parseFloat(c?.ColData[9]?.value).toFixed(2).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) ||
                  (0).toFixed(2).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
          );
          columnTotal[10] +=
            c?.ColData[1]?.value === '' ? 0 : parseFloat(c?.ColData[1]?.value || 0);

          const tableRowObj = {
            client: toProperCase(c?.ColData[0]?.value),
            current:
              c?.ColData[1].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[1]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[1]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[1]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            zerotofifteendays:
              c?.ColData[2].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[2]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[2]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[2]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            sixteentothirtydays:
              c?.ColData[3].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[3]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[3]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[3]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            thirtyonetofortyfivedays:
              c?.ColData[4].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[4]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[4]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[4]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            fortysixtosixtydays:
              c?.ColData[5].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[5]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[5]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[5]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            sixtyonetoseventyfivedays:
              c?.ColData[6].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[6]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[6]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[6]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            seventysixtonintydays:
              c?.ColData[7].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[7]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[7]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[7]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            morethannintyonedays:
              c?.ColData[8].value === '' ? (
                'N/A'
              ) : Number(parseFloat(c?.ColData[8]?.value).toFixed(2)) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[8]?.value) * -1).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[8]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
            pastduebalance:
              (
                parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
              ).toFixed(2) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(
                    (
                      parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                      parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                      parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                      parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                      parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                      parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                      parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
                    ).toFixed(2) * -1,
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })})`}
                </span>
              ) : (
                `$${Number(
                  (
                    parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
                    parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
                    parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
                    parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
                    parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
                    parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
                    parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value)
                  ).toFixed(2),
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),

            overalloutstanding:
              parseFloat(c?.ColData[9]?.value === '' ? 0 : c?.ColData[9]?.value).toFixed(2) < 0 ? (
                <span style={{ color: 'red' }}>
                  {`(-$${Number(parseFloat(c?.ColData[9]?.value).toFixed(2) * -1).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )})`}
                </span>
              ) : (
                `$${Number(parseFloat(c?.ColData[9]?.value).toFixed(2)).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              ),
          };

          tableData.push(tableRowObj);
        }

        totalCellCollection += parseFloat(
          parseFloat(c?.ColData[2].value === '' ? 0 : c?.ColData[2]?.value) +
            parseFloat(c?.ColData[3].value === '' ? 0 : c?.ColData[3]?.value) +
            parseFloat(c?.ColData[4].value === '' ? 0 : c?.ColData[4]?.value) +
            parseFloat(c?.ColData[5].value === '' ? 0 : c?.ColData[5]?.value) +
            parseFloat(c?.ColData[6].value === '' ? 0 : c?.ColData[6]?.value) +
            parseFloat(c?.ColData[7].value === '' ? 0 : c?.ColData[7]?.value) +
            parseFloat(c?.ColData[8].value === '' ? 0 : c?.ColData[8]?.value),
        );
      }
    });
    const columnTotalObj = {
      client: 'Total',
      current:
        columnTotal[1] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[1]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      zerotofifteendays:
        columnTotal[0] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[0]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      sixteentothirtydays:
        columnTotal[2] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[2]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      thirtyonetofortyfivedays:
        columnTotal[3] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[3]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      fortysixtosixtydays:
        columnTotal[4] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[4]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      sixtyonetoseventyfivedays:
        columnTotal[5] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[5]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      seventysixtonintydays:
        columnTotal[6] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[6]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      morethannintyonedays:
        columnTotal[7] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[7]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      pastduebalance:
        columnTotal[8] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[8]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
      overalloutstanding:
        columnTotal[9] === 0
          ? 'N/A'
          : `$${Number(parseFloat(columnTotal[9]).toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`,
    };
    tableData.push(columnTotalObj);
    const pastDueInvoices = pastDueInvoicesArr?.reportResult
      ? pastDueInvoicesArr?.reportResult
      : [];
    const pastDueInvTotalYtd = await findObjectBySearchText(pastDueInvoices, 'GrandTotal');

    const totalCompanyCollection = parseFloat(
      pastDueInvTotalYtd?.object?.Summary?.ColData[
        pastDueInvTotalYtd?.object?.Summary?.ColData.length - 1
      ]?.value,
    );

    const tableObject = {
      columns: reportObj?.Columns?.Column,
      rows: tableData,
      totalTopFive: parseFloat(columnTotal[8]).toFixed(2),
      totalCellCollection,
      totalCompanyCollection,
    };

    setPastDueTableObject(tableObject);
  };

  const createCollectionDataFromImport = async (data) => {
    const importedDataArray = [];
    const totals = {
      currentAmount: 0,
      past1to15: 0,
      past16to30: 0,
      past31to45: 0,
      past46to60: 0,
      past61to75: 0,
      past76to90: 0,
      past91: 0,
      pastDueBalance: 0,
      overallOutstanding: 0,
    };

    data
      ?.filter((d) => d?.cellId === loggedInUserData?.cellId)
      .map((item, index) => {
        if (index < 5) {
          const pastDueBalance =
            parseFloat(item?.past1to15 || 0) +
            parseFloat(item?.past16to30 || 0) +
            parseFloat(item?.past31to45 || 0) +
            parseFloat(item?.past46to60 || 0) +
            parseFloat(item?.past61to75 || 0) +
            parseFloat(item?.past76to90 || 0) +
            parseFloat(item?.past91 || 0);

          const overallOutstanding = parseFloat(item?.currentAmount || 0) + pastDueBalance || 0;

          importedDataArray.push({
            client: item?.clientName,
            current: formatToCurrency(item?.currentAmount, classes),
            zerotofifteendays: formatToCurrency(item?.past1to15, classes),
            sixteentothirtydays: formatToCurrency(item?.past16to30, classes),
            thirtyonetofortyfivedays: formatToCurrency(item?.past31to45, classes),
            fortysixtosixtydays: formatToCurrency(item?.past46to60, classes),
            sixtyonetoseventyfivedays: formatToCurrency(item?.past61to75, classes),
            seventysixtonintydays: formatToCurrency(item?.past76to90, classes),
            morethannintyonedays: formatToCurrency(item?.past91, classes),
            pastduebalance: formatToCurrency(pastDueBalance, classes),
            overalloutstanding: formatToCurrency(overallOutstanding, classes),
            tableData: { id: index },
            cellId: item?.cellId,
          });

          // Update totals
          totals.currentAmount += parseFloat(item?.currentAmount || 0);
          totals.past1to15 += parseFloat(item?.past1to15 || 0);
          totals.past16to30 += parseFloat(item?.past16to30 || 0);
          totals.past31to45 += parseFloat(item?.past31to45 || 0);
          totals.past46to60 += parseFloat(item?.past46to60 || 0);
          totals.past61to75 += parseFloat(item?.past61to75 || 0);
          totals.past76to90 += parseFloat(item?.past76to90 || 0);
          totals.past91 += parseFloat(item?.past91 || 0);
          totals.pastDueBalance += parseFloat(pastDueBalance || 0);
          totals.overallOutstanding += parseFloat(overallOutstanding || 0);
        }
      });

    setPastDueTop5Collection(formatToCurrency(parseFloat(totals.overallOutstanding, classes)));

    importedDataArray.push({
      client: 'Total',
      current: formatToCurrency(totals?.currentAmoun, classes),
      zerotofifteendays: formatToCurrency(totals?.past1to15, classes),
      sixteentothirtydays: formatToCurrency(totals?.past16to30, classes),
      thirtyonetofortyfivedays: formatToCurrency(totals?.past31to45, classes),
      fortysixtosixtydays: formatToCurrency(totals?.past46to60, classes),
      sixtyonetoseventyfivedays: formatToCurrency(totals?.past61to75, classes),
      seventysixtonintydays: formatToCurrency(totals?.past76to90, classes),
      morethannintyonedays: formatToCurrency(totals?.past91, classes),
      pastduebalance: formatToCurrency(totals?.pastDueBalance, classes),
      overalloutstanding: formatToCurrency(totals?.overallOutstanding, classes),
      tableData: 6,
      cellId: loggedInUserData?.cellId,
    });

    setDisplayedTcData([]);
    setDisplayedTcData(importedDataArray);
  };

  const loadPastDueTableByCell = async () => {
    if (cellDetails?.qbId) {
      const pastDueTable = pastDueTableArr;
      fillPastDueTotals(pastDueTable?.reportResult ? pastDueTable?.reportResult : []);
    }
  };

  const loadCollectionDataFromImport = async () => {
    const result = collectionDataFromImportProp;
    if (result?.crResult && result?.crResult?.length > 0) {
      createCollectionDataFromImport(result?.crResult);
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    loadPastDueTableByCell();
  }, []);

  useEffect(() => {
    loadCollectionDataFromImport().then((data) => {
      if (!data) loadPastDueTableByCell();
    });
  }, []);

  useEffect(() => {
    loadCollectionDataFromImport();
  }, [pastDueTop5Collection]);

  const handleColumnClick = () => {
    // Update the state to track the clicked column
    setShow(!show); // Toggle the show state
  };

  return (
    <>
      <If condition={isLoaded}>
        <If condition={cellDetails?.qbId || displayedTcData?.length}>
          {' '}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5">Collections Report</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          My Cell&rsquo;s Top 5 Collections Accounts
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {displayedTcData?.length > 0
                          ? pastDueTop5Collection
                          : formatToCurrency(pastDueTableObject?.totalTopFive, classes)}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        className={classes.CollectionsReportDueBalance}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          My Cell&rsquo;s Total Collections Accounts
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {isFromImport
                          ? formatToCurrency(totalCellAmount, classes)
                          : formatToCurrency(pastDueTableObject?.totalCellCollection, classes)}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        className={classes.CollectionsReportDueBalance}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className={clsx(classes.innercontentWhite)}>
                  <Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Box>
                        <Typography
                          variant="h5"
                          noWrap
                          className={classes.CollectionsReportSectionHeading}
                        >
                          Company Total Collections Accounts
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="h2" noWrap className={classes.CollectionsReportRedText}>
                        {isFromImport
                          ? formatToCurrency(totalCountryAmount.toFixed(2), classes)
                          : formatToCurrency(
                              pastDueTableObject?.totalCompanyCollection?.toFixed(2),
                              classes,
                            )}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        className={classes.CollectionsReportDueBalance}
                      >
                        Past Due Balance
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} className={classes.TableTotalUI}>
                <Box
                  className={clsx(classes.innercontentWhite, classes.CollectionsReportTableMobile)}
                >
                  <MaterialTable
                    style={{ boxShadow: 'none' }}
                    className={classes.materialDT}
                    options={{
                      toolbar: false,
                      draggable: false,
                      paging: false,
                      sorting: false,
                      pageSize: 20,
                      pageSizeOptions: [10, 20, 50, 100],
                      showTextRowsSelected: false,
                      toolbarButtonAlignment: 'right',
                      showFirstLastPageButtons: false,
                      actionsColumnIndex: -100,
                      emptyRowsWhenPaging: false,
                      headerStyle: {
                        position: 'sticky',
                        top: 0,
                        backgroundColor: '#f5f5f5',
                        fontWeight: 'bold',
                        zIndex: 2,
                      },
                    }}
                    localization={{
                      pagination: {
                        labelRowsSelect: 'Rows',
                        labelRowsPerPage: 'Rows Per Page',
                      },
                    }}
                    title="Collections Report"
                    columns={[
                      {
                        title: (
                          <span
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <span>Client</span>
                            <span style={{ display: 'flex', minWidth: 'auto' }}>
                              <img
                                src={
                                  show
                                    ? require('../../../../assets/images/ExpandFilled.svg').default
                                    : require('../../../../assets/images/CollapseFilled.png')
                                        .default
                                }
                                onClick={() => handleColumnClick()}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleColumnClick();
                                  }
                                }}
                                alt={show ? 'Expand' : 'Collapse'}
                              />
                            </span>
                          </span>
                        ),
                        field: 'client',
                        render: (data) => data?.client,
                        sorting: false,
                        cellStyle: () => ({
                          ...(show
                            ? {
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }
                            : {}),
                          ...{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: '#ffffff',
                            zIndex: 1,
                          },
                        }),
                      },
                      {
                        title: <span>Current</span>,
                        field: 'current',
                        render: (data) => formatToCurrency(data?.current, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            0-15 days
                          </span>
                        ),
                        field: 'zerotofifteendays',
                        render: (data) => formatToCurrency(data?.zerotofifteendays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            16-30 days
                          </span>
                        ),
                        field: 'sixteentothirtydays',
                        render: (data) => formatToCurrency(data?.sixteentothirtydays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            31-45 days
                          </span>
                        ),
                        field: 'thirtyonetofortyfivedays',
                        render: (data) => formatToCurrency(data?.thirtyonetofortyfivedays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            46-60 days
                          </span>
                        ),
                        field: 'fortysixtosixtydays',
                        render: (data) => formatToCurrency(data?.fortysixtosixtydays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            61-75 days
                          </span>
                        ),
                        field: 'sixtyonetoseventyfivedays',
                        render: (data) =>
                          formatToCurrency(data?.sixtyonetoseventyfivedays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            76-90 days
                          </span>
                        ),
                        field: 'seventysixtonintydays',
                        render: (data) => formatToCurrency(data?.seventysixtonintydays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            &lt;91
                          </span>
                        ),
                        field: 'morethannintyonedays',
                        render: (data) => formatToCurrency(data?.morethannintyonedays, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Past Due <br />
                            Balance
                          </span>
                        ),
                        field: 'pastduebalance',
                        render: (data) => formatToCurrency(data?.pastduebalance, classes),
                        sorting: false,
                      },
                      {
                        title: (
                          <span>
                            Overall <br />
                            Outstanding
                          </span>
                        ),
                        field: 'overalloutstanding',
                        render: (data) => formatToCurrency(data.overalloutstanding, classes),
                        sorting: false,
                      },
                    ]}
                    data={
                      displayedTcData?.length ? displayedTcData : pastDueTableObject?.rows || []
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </If>
        <If condition={!cellDetails?.qbId || !displayedTcData.length}>
          Please add your cell&rsquo;s Quickbooks Id in the system to see collection section
        </If>
      </If>
    </>
  );
};
CollectionReport.propTypes = {
  collectionDataFromImportProp: PropTypes.arrayOf(PropTypes.object).isRequired, // Adjust the type as needed
  pastDueInvoicesArr: PropTypes.arrayOf(PropTypes.object).isRequired, // Adjust the type as needed
  pastDueTableArr: PropTypes.arrayOf(PropTypes.object).isRequired, // Adjust the type as needed
};
export default CollectionReport;
